module.exports = __webpack_public_path__ + "static/media/kevin.e3cdd0e3.png";